import { typographyScale } from '../typography-scale';

/**
 * Code ownership: Organic growth
 */

export interface ContentTypography {
  contentHero0: string;
  contentHero1: string;
  contentHero2: string;
  contentHero3: string;
  contentHero4: string;
  contentHero5: string;
  contentHeadline1: string;
  contentHeadline2: string;
  contentHeadline3: string;
  contentHeadline4: string;
  contentHeadline5: string;
  contentBodyXLg: string;
  contentBodyLg: string;
  contentBodyMd: string;
  contentBodySm: string;
  contentDetailLg: string;
  contentDetailMd: string;
  contentDetailSm: string;
  contentNumberXL: string;
  contentNumberL: string;
  contentNumberM: string;
  contentNumberS: string;
  contentNumberXS: string; // Optional, not defined in the original code
}

export const contentTypography: ContentTypography = {
  contentHero0: 'text-[176px] leading-[85%] font-[400] font-hero',
  contentHero1: 'text-[144px] leading-[85%] font-[400] font-hero',
  contentHero2: 'text-[88px] leading-[85%] font-[400] font-hero',
  contentHero3: 'text-[68px] leading-[85%] font-[400] font-hero',
  contentHero4: 'text-[52px] leading-[85%] font-[400] font-hero',
  contentHero5: 'text-250 leading-[85%] font-[400] font-hero',
  contentHeadline1: 'text-175 leading-tight font-semibold font-heading',
  contentHeadline2: 'text-150 leading-tight font-semibold font-heading',
  contentHeadline3: 'text-112-5 leading-tight font-semibold font-heading',
  contentHeadline4: 'text-100 leading-tight font-semibold font-heading',
  contentHeadline5: 'text-87-5 leading-tight font-semibold font-heading',
  contentBodyXLg: 'text-150 leading-[1.3] weight-regular font-body',
  contentBodyLg: 'text-125 leading-[1.3] weight-regular font-body',
  contentBodyMd: 'text-112-5 leading-snug weight-regular font-body',
  contentBodySm: 'text-100 leading-snug weight-regular font-body',
  contentDetailLg: typographyScale.bodySm,
  contentDetailMd: typographyScale.bodyXs,
  contentDetailSm: 'text-62-5 leading-normal weight-regular font-body',
  contentNumberXL: 'text-[104px] leading-[85%] font-[400] font-hero',
  contentNumberL: 'text-400 leading-[85%] font-[400] font-hero',
  contentNumberM:
    'text-250 leading-[90%] font-[400] font-hero tracking-[0.01em]',
  contentNumberS:
    'text-200 leading-[90%] font-[400] font-hero tracking-[0.01em]',
  contentNumberXS:
    'text-150 leading-[90%] font-400] font-hero tracking-[0.01em]',
};
